import { gsap } from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import Lenis from "@studio-freight/lenis";
import Splitting from "splitting";

const useLenis = () => {
	const lenis = new Lenis({
		duration: 1.5,
		 easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
		direction: "vertical", // vertical, horizontal
		gestureDirection: "vertical", // vertical, horizontal, both
		smooth: false,
		mouseMultiplier: 1,
		smoothTouch: false,
		touchMultiplier: 2,
		infinite: false,
	});

	//get scroll value
	// lenis.on("scroll", ({ scroll, limit, velocity, direction, progress }) => {
	// 	console.log({ scroll, limit, velocity, direction, progress });
	// });

	function raf(time) {
		lenis.raf(time);
		requestAnimationFrame(raf);
	}

	// requestAnimationFrame(raf);

	document
		.querySelector("[data-scroll-to]")
		.addEventListener("click", () => lenis.scrollTo(document.querySelector("#buy_section")));
};

const useSplitting = () => {
	Splitting({
		target: ".split-words",
		by: "words",
		matching: "span",
	});
};

// const useVideoPeresntation = () => {
// 	const canvas = document.getElementById("renderer");
// 	const context = canvas.getContext("2d");

// 	canvas.width = 1920;
// 	canvas.height = 1080;
// 	// canvas.width = window.innerWidth / 2;
// 	// canvas.height = window.innerWidth / 2 / 1.77;
// 	// canvas.height = 770;

// 	const frameCount = 126;
// 	const currentFrame = (index) => `http://localhost:1234/render/5.25.${index + 1}.png`;

// 	const images = [];
// 	const bodycare = {
// 		frame: 0,
// 	};

// 	for (let i = 0; i < frameCount; i++) {
// 		const img = new Image();
// 		img.src = currentFrame(i);
// 		images.push(img);
// 	}

// 	images[0].onload = render;

// 	function render() {
// 		console.log(1);
// 		context.clearRect(0, 0, canvas.width, canvas.height);
// 		context.drawImage(images[bodycare.frame], 0, 0);
// 	}
// };

function app() {
	gsap.registerPlugin(ScrollTrigger);
	// gsap.to("#story_section", { autoAlpha: 0 });

	useLenis();
	useSplitting();
	// useVideoPeresntation();

	const heroTextTl = gsap.timeline();
	heroTextTl.from("#hero_text .word", { opacity: 0, yPercent: 130, stagger: 0.06, ease: "back.out" }, 0.2);

	const introTl = gsap.timeline({
		scrollTrigger: {
			trigger: "#intro_section",
			start: "top top",
			end: "=+100% top",
			scrub: 1,
			pin: true,
			pinSpacing: false,
			markers: false,
		},
	});

	introTl.to("#symbol", { scale: 2, autoAlpha: 0, ease: "none" }, 0).to("#hero_text", { scale: 4, autoAlpha: 0, ease: "none" }, "<").to("#intro_section", { autoAlpha: 0 }, ">=-0.5");

	// titles
	const titleItems = gsap.utils.toArray("[data-title-anim]");
	titleItems.forEach((title) => {
		const textWord = title.querySelectorAll(".word");
		const titleTl = gsap.timeline({
			scrollTrigger: {
				trigger: textWord,
				start: "top 100%",
				end: "100% 100%",
				toggleActions: "restart none reverse none",
				markers:false,
			},
		});
		titleTl.from(textWord, { opacity: 0, yPercent: 130, stagger: 0.06, ease: "back.out" }, 1);
	});
	// titles
	const paraphItems = gsap.utils.toArray("[data-paraph-anim]");
	paraphItems.forEach((paraph) => {
		const paraphTl = gsap.timeline({
			scrollTrigger: {
				trigger: paraph,
				start: "top 100%",
				end: "100% 100%",
				toggleActions: "restart none reverse none",
				markers: false,
			},
		});
		paraphTl.from(paraph, { opacity: 0, yPercent: 130, ease: "back.out" }, 0);
	});
	// titles
	const fadeInItems = gsap.utils.toArray("[data-fadeIn-anim]");
	fadeInItems.forEach((paraph) => {
		const paraphTl = gsap.timeline({
			scrollTrigger: {
				trigger: paraph,
				start: "top 100%",
				end: "100% 100%",
				toggleActions: "restart none reverse none",
				markers: false,
			},
		});
		paraphTl.from(paraph, { opacity: 0, yPercent: 100, ease: "back.out" }, 1.5);
	});

	const mainTl = gsap.timeline({
		scrollTrigger: {
			trigger: "#main_section",
			start: "top top",
			end: "bottom bottom",
			scrub: 1,
			pin: true,
			pinSpacing: false,
			markers: false,
		},
	});

	// Stacked
	const stackedCards = gsap.utils.toArray(".stacked_img");
	mainTl.to("#main_title", { yPercent: -200 }, "<");

	stackedCards.forEach((item, index) => {
		mainTl.fromTo(
			item,
			{
				yPercent: 150,
				autoAlpha: 0,
				scale: 2,
				yoyo: true,
				ease: "ease.out",
			},
			{
				yPercent: -80 * index,
				autoAlpha: 1,
				scale: 0.8 + index * 0.1,
				yoyo: true,
				ease: "ease.out",
			},
			"+=10%"
		);
	});

	mainTl.to("#covers_section", { autoAlpha: 0 }, ">+=0.25");
	mainTl.to("#story_section", { yPercent: -100,duration:1 }, "<");
	mainTl.to("#land_video", { width: "50vw" });

	const canvas = document.getElementById("renderer");
	const context = canvas.getContext("2d");

	canvas.width = 1080;
	canvas.height = 864;

	const frameCount = 126;
	const currentFrame = (index) => `https://onlock.ir/frontend/assets/img/bodycare/v3/5.39.${index + 1}.webp`;

	const images = [];
	const bodycare = {
		frame: 0,
	};

	for (let i = 0; i < frameCount; i++) {
		const img = new Image();
		img.src = currentFrame(i);
		images.push(img);
	}

	images[0].onload = render;

	function render() {
		console.log("start rendering movie...");
		context.clearRect(0, 0, canvas.width, canvas.height);
		context.drawImage(images[bodycare.frame], 0, 0);
	}

	gsap.to(bodycare, {
		frame: frameCount - 1,
		snap: "frame",
		ease: "none",
		scrollTrigger: {
			trigger: "#story_section",
			start: "=-33% top",
			end: "bottom bottom",
			scrub: 0.1,
			markers: false,
		},
		onUpdate: render, // use animation onUpdate instead of scrollTrigger's onUpdate
	});

	mainTl.from(
		"#step_1 h3 .word",
		{ opacity: 0, yPercent: 20, stagger: 0.02, ease: "back.out", duration: 0.5 },
		"<+=0.5"
	);
	mainTl.from("#step_1 p", { autoAlpha: 0, yPercent: -130, duration: 0.5 }, "<");

	mainTl.to(
		"#step_1 h3 .word",
		{ opacity: 0, yPercent: 20, stagger: 0.02, ease: "back.out", duration: 0.5 },
		">+=0.5"
	);
	mainTl.to("#step_1 p", { autoAlpha: 0, yPercent: -130, duration: 0.5 }, "<");

	mainTl.from(
		"#step_2 h3 .word",
		{ opacity: 0, yPercent: 20, stagger: 0.02, ease: "back.out", duration: 0.5 },
		"<+=0.25"
	);
	mainTl.from("#step_2 p", { autoAlpha: 0, yPercent: -130, duration: 0.5 }, "<");

	const contentsTl = gsap.timeline({
		scrollTrigger: {
			trigger: "#contents_section",
			start: "top top",
			end: "bottom bottom",
			scrub: 1,
			pin: true,
			pinSpacing: false,
			markers: false,
		},
	});

	contentsTl.to("#layer", { yPercent: -100, duration: 0.5 });
	contentsTl.from(".layer_img", { scale: 1.3, duration: 0.5 }, "<");
}

document.addEventListener("DOMContentLoaded", app);
